<template>
  <b-col id="imprint-container" cols="12" class="content-row px-3 pb-3">
    <BackArrow class="my-3" @back="$emit('back')" />

    <b-row no-gutters> <ImprintTextDe></ImprintTextDe></b-row
  ></b-col>
</template>

<script>
import BackArrow from "@/components/legal/back-arrow.vue";
import ImprintTextDe from "@/components/legal/imprint-text_de.vue";
import ImprintTextEn from "@/components/legal/imprint-text_en.vue";

export default {
  name: "ImprintContainer",
  components: { BackArrow, ImprintTextDe },
};
</script>
